import Shepherd from "shepherd.js";
import stopShowingTour from '../util/tourStatus';

const backButton = {
    text: "Back",
    classes: "waves-effect",
    secondary: true,
};

const nextButton = {
    text: "Next",
    classes: "btn waves-effect",
};

const tour = new Shepherd.Tour({
    defaultStepOptions: {
        buttons: [
            backButton,
            nextButton,
        ],
        cancelIcon: {
            enabled: true
        }
    },
});

backButton.action = tour.back;
nextButton.action = tour.next;

tour.addStep({
    id: "intro",
    title: "We're here to help",
    text: 'Contact us at:<ul class="browser-default"><li>' + supportContactPhone + '</li><li><a href="mailto:' + supportContactEmail + '">' + supportContactEmail + '</a></li></ul>Or take tour...',
    attachTo: { element: ".brand-logo", on: 'bottom' },
    buttons: [
        {
            text: "I know my way around",
            classes: "forget-tour",
            secondary: true,
            action: function () {
                stopShowingTour($('#tour-id-number').val());
                return tour.cancel();
            },
        },
        { ...nextButton, text: "Start Tour" },
    ]
});

tour.addStep({
    id: 'header-sections',
    text: "These tabs are used to navigate major sections of the assessment",
    attachTo: { element: ".tabs", on: 'bottom' },
});

tour.addStep({
    id: 'indicators-1',
    text: "These indicators show where you currently are in the current header section",
    attachTo: { element: ".headerSection.active .indicator-item", on: 'bottom' },
});

tour.addStep({
    id: 'indicators-2',
    text: "Clicking on one of these will navigate you that specific question",
    attachTo: { element: ".headerSection.active .indicator-item", on: 'bottom' },
});

tour.addStep({
    id: 'indicator',
    text: "These will fill with the colour of the rating you provide for that question",
    attachTo: { element: ".headerSection.active .indicator-item", on: 'bottom' },
});

tour.addStep({
    id: 'rating',
    text: "To provide a rating you click the circle over here",
    attachTo: { element: ".headerSection.active .carousel-item.active .rating-trigger", on: 'bottom' },
});

tour.addStep({
    id: 'upload-evidence',
    text: "To upload evidence we need to first open your library window over here",
    attachTo: { element: '.headerSection.active .carousel-item.active .upload-btn', on: 'left' },
});

tour.addStep({
    id: 'upload-evidence-dropbox',
    text: "To upload new evidence to your library you can drop them here or click on the grey area",
    attachTo: { element: '#upload-modal .dropbox', on: 'bottom' },
    beforeShowPromise: () => new Promise(
        resolve => resolve($('.headerSection.active .carousel-item.active .upload-btn').click())
    ),
});

tour.addStep({
    id: 'upload-evidence-library',
    text: "When you have evidence in your library, you'll see them show up here",
    attachTo: { element: '#upload-modal .existing-files', on: 'top' },
});

tour.addStep({
    id: 'upload-evidence-done',
    text: "Once you're done, you can save your changes by clicking done here",
    attachTo: { element: '#upload-modal .modal-done', on: 'bottom' },
});

tour.addStep({
    id: 'upload-evidence-cancel',
    text: "Or if you'd like to discard changes, you can click cancel. <br> Please note that this does not remove uploaded evidence from your library",
    attachTo: { element: '#upload-modal .modal-close', on: 'bottom' },
});

tour.addStep({
    id: 'upload-evidence-list',
    text: "Once you've attached evidence to this question, it'll show up here",
    attachTo: { element: '.headerSection.active .carousel-item.active .upload-name-list', on: 'left' },
    beforeShowPromise: () => new Promise(
        resolve => resolve($('#upload-modal .modal-close').click())
    )
});

tour.addStep({
    id: 'write-evidence',
    text: "You can write about your evidence here",
    attachTo: { element: '.headerSection.active .carousel-item.active .customer-response', on: 'bottom' },
});

tour.addStep({
    id: 'to-do-list',
    text: "See a summary of the assessment in your 'To-Do List' here",
    attachTo: { element: ".todo-list-button", on: 'top' },
});

tour.addStep({
    id: 'save-draft',
    text: "At any point you want to save your work you can click Save draft",
    attachTo: { element: ".footer button[value='Save']", on: "left" },
});

tour.addStep({
    id: 'submit',
    text: "Once you've finished by filling in everything in the To-do list you can submit it for review here",
    attachTo: { element: ".footer button[value='Submit']", on: 'left' },
});

tour.addStep({
    id: 'ending',
    title: "Thats all you need to know!",
    text: "We hope you like the Self Assessment App",
    buttons: [
        backButton,
        {
            text: "Don't show me this again",
            classes: "btn waves-effect forget-tour",
            action: function () {
                stopShowingTour($('#tour-id-number').val());
                return tour.cancel();
            },
        },
    ]
});

export default tour;